<template>
  <v-content>
    <v-container fluid>
      <v-col cols="12">
        <v-card raised>
          <v-card color="#385F73" height="315" dark>
            <v-container>
              <v-row>
                <v-col cols="12" v-bind:md="this.$store.state.globals.mini ? 8 : 7">
                  <v-card-title class="headline">{{ individualmodule.title }}</v-card-title>
                  <v-card-subtitle class="pt-5" v-html='individualmodule.glossary'></v-card-subtitle>
                <v-chip-group class="deep-grey accent-4 white--text" column>
                  <v-chip v-for='(coursedata,index) in individualmodule.courses' :key='index'>
                    {{ coursedata.course_name }}
                  </v-chip>
                  <v-chip>{{ (individualmodule.language.hasOwnProperty('lang_name') ? individualmodule.language.lang_name : '') | translate }} </v-chip>
                </v-chip-group>                   

                </v-col>
                <v-col
                  cols="12"
                  v-bind:md="this.$store.state.globals.mini ? 4 : 5 "
                  style="position: relative"
                >
                  <div id="floatingbox" class="floatingbox">
                    <v-card color="white" class="mx-auto buycard">
                      <v-img
                        class="white--text align-end buyimage"
                        height="200px"
                        :src="storage_url+individualmodule.thumbnail "
                      ></v-img>
                      <v-card-text class="text--primary">
                        <div class="pt-1 pb-1">
                          <h2 class="text-center">{{ individualmodule.title }}</h2>
                        </div>
                        <div
                          class="pt-1 pb-1"
                          v-if="(Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'on-demand' )"
                        >
                        </div>

                        <div
                          class="pt-1 pb-1"
                          v-if="(Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'on-demand' && is_subscribed )"
                        >
                          <h3 class="text-center">{{ 'Purchased'| translate }}</h3>
                        </div>

                        <div
                          class="pt-1 pb-1"
                          v-if="(Object.keys(currentUser).length !=0 && currentUser.company.account_type == 'full-version' )"
                        >
                          <h3 class="text-center">{{ 'Included'| translate }}</h3>
                        </div>

                        <div class="my-2" v-if="(!is_subscribed) || (!currentUser.roles.includes(5) && draftStatus)">
                          <v-btn
                            large
                            block
                            color="error"
                            @click="gottoCourse()"
                            dark
                          >{{ 'Subscribe'| translate }}</v-btn>
                        </div>
                        <div class="my-2" v-if="(is_subscribed) || (currentUser.roles.includes(5) && draftStatus)">
                          <v-btn
                            large
                            block
                            color="success"
                            @click="modulePlayer(module_id)"
                            dark
                          >{{ 'PLAY NOW'| translate }}</v-btn>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <v-container>
            <v-row>
              <v-col cols="12" v-bind:md="$store.state.globals.mini ? 8 : 7 ">
                <v-row>
                  <v-col cols="12" md="12">
                    <div class="pt-4 pb-4 learn">
                      <h3>{{ 'What Will you Learn?'| translate }}</h3>
                      <div class="pt-5">
                        <p v-html="individualmodule.learn"></p>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="12">
                    <div class="pt-4 pb-4">
                      <h3>{{ 'Requirements'| translate }}</h3>
                      <div class="pt-5">
                        <p v-html="individualmodule.requirement"></p>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-row>
                  <v-col cols="12" md="12">
                    <div class="pt-4 pb-4">
                      <h3>{{ 'Description'| translate }}</h3>
                      <div class="pt-5">
                        <p v-html="individualmodule.long_description"></p>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <v-divider></v-divider>

                <v-row>
                  <v-col cols="12" md="12" class="pt-4 pb-4">
                    <v-row v-for="authorsdata in individualmodule.authors"
                      :key="authorsdata.author_id">
                      <v-col cols="12" md="3">
                        <v-layout column align-center>
                          <v-flex class="mt-5">
                            <v-avatar size="100">
                              <v-img
                                class="elevation-6"
                                :src="storage_url+ authorsdata.author_pic"
                              ></v-img>
                            </v-avatar>
                          </v-flex>
                        </v-layout>
                      </v-col>
                      <v-col cols="12" md="9">
                        <h3>{{ authorsdata.author_name }}</h3>
                        <div class="pt-5">
                          <p>{{ authorsdata.author_info }}</p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-container>
  </v-content>
</template>

<style lang="scss" scoped>
@media screen and (min-width: 1161px) {
  .floatingbox {
    position: fixed;
    top: 227px;
    right: 70px;
    max-width: 350px;
  }
}

@media screen and (min-width: 1110px) and (max-width: 1160px) {
  .floatingbox {
    position: fixed;
    top: 227px;
    max-width: 320px;
    right: 60px;
  }
}

@media screen and (min-width: 1070px) and (max-width: 1109px) {
  .floatingbox {
    position: fixed;
    top: 227px;
    max-width: 290px;
    right: 50px;
  }
}

@media screen and (min-width: 961px) and (max-width: 1069px) {
  .floatingbox {
    position: fixed;
    top: 227px;
    max-width: 270px;
    right: 42px;
  }
}

@media screen and (max-width: 961px) {
  .floatingbox {
    position: sticky;
    top: 0;
  }

  .learn {
    margin-top: 90px;
  }

  .buyimage {
    display: none;
  }
}

.learn {
  background-color: #f9f9f9;
  border: 1px solid #dedfe0;
  padding: 10px 15px;
}
</style>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import {
  FETCH_INDIVIDUAL_MODULE,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";
export default {
  name: "ModulesDetails",
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_INDIVIDUAL_MODULE, to.params.id).then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false);
        store.commit(SET_ROUTER_ENTER, false)

      }
    });

    return next();
  },
  computed: {
    ...mapGetters([
      "individualmodule",
      "stripesecretkey",
      "currentUser",
      "loadingdata",
      "languages"
    ])
  },
  mounted() {
    this.storage_url  = process.env.VUE_APP_STORAGE_URL
    this.module_id = this.individualmodule.module_id;
    this.is_subscribed = this.individualmodule.is_subscribed
    this.price = this.individualmodule.plan
    this.module_slug = this.individualmodule.slug;
    this.individualmodule.courses.forEach(data => {
      if(data.course_status === "draft") {
        this.draftStatus = true
        return;
      }
    });

  },
  data: function() {
    return {
      module_id: null,
      module_slug: null,
      is_subscribed: null,
      dialog: false,
      price: null,
      storage_url: '',
      profileLink: false,
      draftStatus: false,
      };
  },
  methods: {
    modulePlayer(id) {
      this.$router.push("/moduleplayer/" + id);
    },
    gottoCourse(){
      this.$router.push("/courses");
    },
  }
};
</script>